<template>
  <div class="relative bg-gray-800 rounded-xl p-4 mt-4 text-sm text-white shadow-lg border-2">
    <div class="grid grid-cols-2">
      <span class="flex">
        <OfficeBuildingIcon class="w-5 h-5 text-brand"/>
        <span class="mr-1">اتاق: {{ serviceRequest.room.number }}</span>
      </span>
      <span class="flex items-center">
        <BookmarkIcon class="h-5 w-5 text-brand"/>
        <span class="mr-1">{{ serviceRequest.service.name }}</span>
      </span>
    </div>

    <div class="grid grid-cols-2 mt-3">
      <span class="flex">
          <HashtagIcon class="h-5 w-5 text-brand"/>
          <span class="mr-1">{{ serviceRequest.count }} عدد</span>
      </span>
      <span class="flex">
        <EyeIcon class="h-5 w-5 text-brand"/>
        <span class="mr-1" :class="statusClass()">{{ status(serviceRequest.status) }}</span>
      </span>
    </div>

    <div class="grid grid-cols-2 mt-3">
      <span class="flex">
        <ClockIcon class="h-5 w-5 text-brand"/>
        <span class="mr-1">{{ serviceRequest.created_at }}</span>
      </span>
    </div>

  </div>

</template>

<script>
import {BookmarkIcon, ClockIcon, EyeIcon, HashtagIcon, OfficeBuildingIcon} from '@heroicons/vue/outline'

export default {
  name: "ServiceRequestCard",
  components: {
    OfficeBuildingIcon,
    ClockIcon,
    BookmarkIcon,
    EyeIcon,
    HashtagIcon,
  },
  props: ['serviceRequest'],
  data() {
    return {
      statusDialog: false,
      statusType: ''
    }
  },
  methods: {
    statusClass() {
      switch (this.serviceRequest.status) {
        case 'pending':
          return 'text-yellow-500'
        case 'seen':
          return 'text-purple-500'
        case 'delivered':
          return 'text-green-500'
      }
    },
    status(status) {
      switch (status) {
        case 'pending':
          return 'در انتظار'
        case 'seen':
          return 'دیده شده'
        case 'delivered':
          return 'تحویل شده'
      }
    },

  }
}
</script>

<style scoped>
</style>